import React from 'react';
import { SearchContext } from 'src/providers';

export function useSearch() {
  return React.useContext(SearchContext);
}
